import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useI18n } from '../lib/i18n';
import { TimelineView, type TimelineItem } from './TimelineView';

/** Timeline del PROCESO DE PAGOS (pestaña Payments): cheque recibido → depositado/disponible →
 *  invoice creado/aprobado/emitido → pago autorizado al contractor → pagado. Con link para ver
 *  el cheque, el PDF del invoice, la prueba de autorización y el comprobante de pago. */
export function PaymentsTimeline({ claimId }: { claimId: string }) {
  const { t } = useI18n();
  const [items, setItems] = useState<TimelineItem[] | null>(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let alive = true;
    api.get<{ items: TimelineItem[] }>(`/api/claims/${claimId}/payments-timeline`)
      .then((r) => { if (alive) setItems(r.items); })
      .catch(() => { if (alive) setErr(true); });
    return () => { alive = false; };
  }, [claimId]);

  return (
    <TimelineView
      claimId={claimId}
      items={items}
      error={err}
      tPrefix="payTl"
      sendDept="payments"
      sendRecipients={['contractor', 'homeowner']}
      title={t('payTl.title')}
      subtitle={t('payTl.subtitle')}
      emptyText={t('payTl.empty')}
    />
  );
}
